export default "__VITE_ASSET__okmbke2I__"